module.exports = __webpack_public_path__ + "img/desktop-elbow-9_72x86.14778607.png";